module.exports = __webpack_public_path__ + "src/img/artist/work04_2.jpg?1a388d4156f8bd7fbf43026bd002b006";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work04_2.jpg
// module id = 153
// module chunks = 0